import { useCallback, useRef, useState } from "react";
import AnchoredPanel from "../../../GlobalComponents/AnchoredPanel/AnchoredPanel";

/**
 * A "Columns" button that opens a checklist of the grid's columns. Locked
 * columns are listed but cannot be unticked.
 *
 * @param {object} props
 * @param {{ key: string, label: string, locked?: boolean }[]} props.columns
 * @param {Set<string>} props.hidden keys currently hidden
 * @param {(key: string) => void} props.onToggle
 * @param {() => void} props.onShowAll
 */
export default function ColumnPicker({ columns, hidden, onToggle, onShowAll }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);

  const shown = columns.length - hidden.size;

  return (
    <div className="kgb-colpicker" ref={rootRef}>
      <button
        type="button"
        className="kgb-btn"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        Columns <span className="kgb-colpicker-count">{shown}/{columns.length}</span>
      </button>
      {open ? (
        <AnchoredPanel
          anchorRef={rootRef}
          onClose={close}
          align="right"
          className="kgb-picker kgb-colpicker-panel"
        >
          <p className="kgb-picker-title">Show columns</p>
          {columns.map((column) => (
            <label key={column.key} className="kgb-colpicker-option">
              <input
                type="checkbox"
                className="kgb-checkbox"
                checked={!hidden.has(column.key)}
                disabled={column.locked}
                onChange={() => onToggle(column.key)}
              />
              {column.label}
            </label>
          ))}
          <div className="kgb-editor-actions">
            <button type="button" className="kgb-btn kgb-btn--quiet" disabled={hidden.size === 0} onClick={onShowAll}>
              Show all
            </button>
          </div>
        </AnchoredPanel>
      ) : null}
    </div>
  );
}
